/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><div class="page"><es-over-layout :layout="(['header', 'footer'])" :useDefaultNavbar="(false)" custom-main="custom-main" :useBlankPage="(loadInitDataFail)" :navbarClickLeft="(confirm)" :blankPageType="(loadInitDataFail ? 'blank-page' :'')" class="es-select"><div slot="header" class="es-select__header"><es-navbar :class="(isManageSimple ? '' : 'es-select__navbar')" custom-class="es-select__navbar" :title="(isManageSimple ? '常用乘车人' : (title?('添加'+ title):''))" :leftArrow="(false)"><div slot="left" v-if="(!isHideLeftArrow)"><es-icon size="24" color="#333333" name="angle-left"></es-icon></div></es-navbar><div class="es-select__header-tip" v-if="(maxContact && !isManageSimple)"><span>已选{{selectedNumber}}/{{maxContact}}人</span></div><div :style="[(selectTips.style)] | transRpxStyle" class="es-select__tips" v-if="(selectTips.text && !isExemption)">{{selectTips.text}}</div></div><div class="es-select__scroll-container"><div><div class="es-select__add"><add-button :text="('添加' + (isManageSimple ? '旅客' : title))" @click="goToAdd"/></div><div class="es-select__content" v-if="(innerList&&innerList.length > 0)"><es-card-del v-for="(item, index) in (innerList)" @click-right="delData(item)" class="page-card"><div slot="mainContext" class="card"><div class="card-left" v-if="(!isManageSimple)"><mpx-view @tap="toggleCheckbox(item)" class="checkbox-container expand-click"><checkbox-icon :checked="(tools.isItemChecked(item, selectedContacts))" :disabled="(tools.isDisableSelect(item, selectedContacts, maxContact, need_card,selectContentConfig)                       || item.mobile_status !== '1'                       || item.user_status !== '1'                       || validatePhoneEmpty(item.mobile_no))"/></mpx-view></div><div class="card-main"><div class="card-title"><span class="username">{{item.passenger_name}}</span><span class="card-tag card-tag__self" v-if="(+item.is_user_self)">本人</span><span class="card-tag" v-if="(item.passenger_type === 0)">成人票</span><span class="card-tag" v-if="(item.passenger_type === 1)">儿童票</span><span class="card-tag" v-if="(item.passenger_type === 2)">学生票</span><span class="card-tag" v-if="(item.passenger_source === 0)">12306</span></div><div class="card-info"><span class="card-tip" v-if="(tools.isMissing(item, need_card, selectContentConfig))">请补全身份信息</span><div><span>{{ item.id_name}}：</span><mpx-text @tap="goToSupply(item)" class="id-tip" v-if="(item.passenger_source === 1 && item.user_status === '3')">证件信息已过期，请补齐<mpx-image mode="aspectFit" src="https://ut-static.udache.com/webx/sfc/q4PIMKjo34T6AnB_EIVEL_clipboard_image_1698899373437.png" class="id-tip-icon"/></mpx-text><span v-else>{{tools.desensitizeCardId(item.encrypt_id_no) }}</span></div></div><template v-if="(item.user_status !== '3')"><mpx-view @tap="jumpToValidateComment(item, 'identity')" class="card-tip" v-if="(item.mobile_status !== '1' && item.user_status !== '1')">联系方式、身份核验未通过<es-icon name="angle-right" size="16" color="#f93822" class="arrow"/></mpx-view><mpx-view @tap="jumpToValidateComment(item, 'identity')" class="card-tip" v-if="(item.mobile_status === '1' && item.user_status !== '1')">身份核验未通过，请去车站窗口核验<es-icon name="angle-right" size="16" color="#f93822" class="arrow"/></mpx-view><mpx-view @tap="jumpToValidateComment(item, 'contact')" class="card-tip" v-if="(item.mobile_status !== '1' && item.user_status === '1')">联系方式核验未通过<es-icon name="angle-right" size="16" color="#f93822" class="arrow"/></mpx-view><mpx-view @tap="goToEdit(item)" class="card-tip" v-else-if="(validatePhoneEmpty(item.mobile_no))">联系方式待填写<es-icon name="angle-right" size="16" color="#f93822" class="arrow"/></mpx-view></template></div><mpx-view @tap="goToEdit(item)" class="card-right"><es-icon name="pencil-edit" size="18" color="#999"/></mpx-view></div><div slot="delContext" class="del-box"><div>删除</div></div></es-card-del></div></div><div class="no-data" v-if="(!innerList.length && !isFristLoad)"><div><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/eXNx7tOkBo1644825801357.png" class="no-data-img"/></div><div v-if="(isHasNoData && scene == '1' && keywords == '')"><div class="no-data-text">代订制度中未选择任何出行人</div><div class="no-data-text">如有疑问请联系管理员进行更改</div></div><div v-if="(isHasNoData && scene == '2' && keywords == '')"><div class="no-data-text">预订请先添加出行人</div></div></div></div><div slot="footer" class="es-select__footer" v-if="(!isManageSimple)"><es-button block type="info" @click="confirm" class="submit-button" :custom-class='["submit-button"].join(" ")'>确定</es-button></div></es-over-layout><es-toast id="es-toast"/><contact-dialog :show="(isShowDialog)" :title="(dialog_title)" cancelText="知道了" :content="(content)" @cancel="close" :showClass="(true)" align="center"></contact-dialog><student-confirm-dialog :show="(isShowStudentConfirmDialog)" @cancel="clickBuyStudent" @confirm="clickBuyAdult"></student-confirm-dialog><student-dialog :show="(isShowStudentDialog)" @cancel="changeSeat" @confirm="clickBuyAdult"></student-dialog><child-dialog :show="(isShowChildDialog)" @cancel="closeDialog"></child-dialog><es-dialog showConfirmButton showCancelButton :show="(isDeleteDialogShow)" @close="confirmDelete"><div slot="content">确认删除{{isExemption ? '常用旅客' : '联系人'}}{{ contactName }}吗?</div></es-dialog><supply-info :supplyInfo="(supplyInfo)" @close="supplyClose" @confirm="supplyConfirm"/></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m39ace3a0"}'>
  .page
    height 100%
    background-color #ffffff
  .custom-main
    background-color #f0f1f4 !important
  .no-data
    font-size 14px
    color #333333
    text-align center
    padding-top 120px
    .no-data-img
      width 100px
      height 100px
      margin-bottom 8px
    .no-data-text
      text-align center
  /deep/ .es-toast
    background-color #000000
    padding 12px 24px
  +b('select')
    /deep/ .es-main
      background-color #f0f1f4
    +e('navbar')
      /deep/ .es-navbar
        height 44px
        background-color #ffffff
    /deep/ .es-navbar__right
      width 28px
    /deep/ .es-navbar__title
      font-size 18px
    +e('header-tip')
      font-size 12px
      line-height 16px
      color #666666
      padding-bottom 5px
      text-align center
      background-color #ffffff
    // +e('flight-tip')
    // padding 8px 12px
    // background linear-gradient(to right, #fff4ee, #fefefe)
    // color #FF6221
    // font-size 12px
    +e('tips')
      color #1167E5
      background linear-gradient(to right, #edf4ff, #fefefe)
      font-size 12px
      padding 8px 12px
    +e('contact_bg')
      display flex
      align-items center
      margin 7px 12px
      overflow-x auto
      scrollbar-width none /* firefox */
      -ms-overflow-style none /* IE 10+ */
      &::-webkit-scrollbar
        display none /* Chrome Safari */
    +e('contact-name')
      font-size 12px
      color #333333
      margin-right 4px
      line-height 12px
    +e('contact-img')
      color #BBBBBB
      width 12px
      height 12px
    +e('contact')
      flex-grow 0
      border-radius 4px
      font-family PingFangSC-Regular
      font-size 12px
      color #333333
      height 28px
      align-items center
      background #F3F4F5
      margin-right 8px
      padding 0px 10px
      display flex
      white-space nowrap
    +e('add')
      padding 10px 12px 0 12px
      font-family PingFangSC-Medium
    +e('content')
      background-color #ffffff
      border-radius 8px
      margin 10px 12px 0 12px
      .page-card
        position relative
        &::after
          border-bottom 1px solid #F0F2F7
          position absolute
          box-sizing border-box
          content ''
          pointer-events none
          right 0
          left 16px
          bottom 0
          transform scaleY(0.5)
        .del-box
          display flex
          justify-content flex-end
          align-items center
          border-radius 8px
          font-size 14px
          font-weight 500
          font-family PingFangSC-Regular
          height 100%
          background #F93822
          padding-right 24px
        .card
          display flex
          padding 20px 16px
          background #fff
          border-radius 8px
          .card-left
            align-self center
            .checkbox-container
              display flex
              align-items center
              padding-right 12px
            .icon-checkbox__disable
              display inline-block
              width 16px
              height 16px
              border 1px solid #D4D3D3
              border-radius 100%
              background #eeeeee
          .card-main
            flex 1
            display flex
            flex-direction column
            justify-content center
            .card-title
              display flex
              align-items center
              .username
                font-size 16px
                line-height 22px
                font-family PingFangSC-Medium
                color #333333
                font-weight 500
                display inline-block
                max-width 112px
                white-space nowrap
                text-overflow ellipsis
                overflow hidden
                margin-right 4px
              .english-name
                color #999999
                font-size 14px
                margin-right 6px
                display inline-block
                max-width 89px
                white-space nowrap
                text-overflow ellipsis
                overflow hidden
              .english-name-show
                font-size 16px
                color #333333
                max-width 120px
                font-family PingFangSC-Medium
              .card-tag
                color #666
                border 1px solid #ccc
                border-radius 4px
                display inline-block
                line-height 1
                font-size 12px
                padding 2px
                transform scale(0.83)
                align-self center
              .card-tag__common
                color #2EA761
              .card-tag__self
                border-color #82CAA0
                color #2EA761
              .card-tag__employee
                color #1473FF
                border-color #73ACFF
              .card-tag__external
                color #999999
                border-color #999999
              .card-tag__disabled
                color #999999
                border-color #999999
            .card-info
              display flex
              flex-direction column
              color #666666
              font-size 12px
              line-height 17px
              margin-top 4px
              word-break break-all
            .card-tip
              display flex
              flex-direction row
              align-items center
              font-size 12px
              color #f93822
              margin-top 8px
            .id-tip
              color #FF4129
              font-size 12px
              display inline-flex
              align-items center
              &-icon
                width 5px
                height 9px
                margin-left 4px
          .card-right
            flex none
            width 18px
            margin-left 8px
            align-self center
            color #666666
    +e('scroll-container')
      // height 100%
      // position relative
      // overflow-y auto
      background-color #f0f1f4
      padding-bottom 12px
      padding-top 1px
      .bottom-tip
        text-align center
        font-size 12px
        padding 10px
        color #999999
    +e('footer')
      flex 1
      padding 16px
      box-shadow 0 -4px 20px 0 rgba(0, 0, 0, 0.04)
      background #ffffff
      z-index 1
      .submit-button
        font-size 16px
        border-radius 8px !important
        background-color #FF6400
        border-color #FF6400
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  wxsModules.tools = require("./select.wxs")
  global.currentModuleId = "m39ace3a0"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./select.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./select.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m39ace3a0"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'es-button':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/button/index.mpx?isComponent&outputPath=components%2Findexbc68cb48%2Findex")),'es-dialog':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/dialog/index.mpx?isComponent&outputPath=components%2Findex3651661c%2Findex")),'es-toast':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/toast/index.mpx?isComponent&outputPath=components%2Findex68e47551%2Findex")),'contact-dialog':getComponent(require("./components/contact-dialog/index.mpx?isComponent&outputPath=components%2Findexd3416d8a%2Findex")),'student-confirm-dialog':getComponent(require("./components/contact-dialog/student-confirm-dialog.mpx?isComponent&outputPath=components%2Fstudent-confirm-dialog5acbaaa8%2Findex")),'student-dialog':getComponent(require("./components/contact-dialog/student-dialog.mpx?isComponent&outputPath=components%2Fstudent-dialog491b6502%2Findex")),'child-dialog':getComponent(require("./components/contact-dialog/child-dialog.mpx?isComponent&outputPath=components%2Fchild-dialog24b6b904%2Findex")),'es-card-del':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/card-del/index.mpx?isComponent&outputPath=components%2Findex1fb7d810%2Findex")),'checkbox-icon':getComponent(require("./components/checkbox-icon/index.mpx?isComponent&outputPath=components%2Findex214602b1%2Findex")),'search-input':getComponent(require("./components/search-input/index.mpx?isComponent&outputPath=components%2Findexdee11fea%2Findex")),'add-button':getComponent(require("./components/add-button/index.mpx?isComponent&outputPath=components%2Findex6e00a244%2Findex")),'supply-info':getComponent(require("./components/supply-info/index.mpx?isComponent&outputPath=components%2Findex45d92afa%2Findex")),'es-over-layout':getComponent(require("../../es-mpx-ui/lib/layout/index.mpx?isComponent&outputPath=components%2Findex2146c876%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-text':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-text.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
